module.exports = __webpack_public_path__ + "static/media/transparency.5ba43bb5.svg";